import BaseService from '@/services/base_service';

export default class RacaService extends BaseService {
    async list(params){
        try{
            return await axios.get('/raca/pesquisar', {
                params: params
            });
        } catch (e) {
            throw e;
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/raca.js